import Modal from '@/components/modal';
import { FontStyle } from '@/components/style';

export default class LoadingModal extends Modal {
  style = `
    <style>
        .description-box {
            text-align: center;
            /*position: absolute;*/
            /*top: 40vh;*/
        }
    </style>
  `;
  message = `Your Custom Results<br/> Are <span class="title-font-15">Loading!</span>`;
  renderHeader() {
    return '';
  }

  renderBody() {
    return `
    ${FontStyle}
    ${this.style}
    <div
        style="
            margin-top: 10%;
            background-image: url('${this.image}');
            background-color: #fbf5f0;
            height: 100vh;
            width: 100vw;
            background-repeat: no-repeat;
            background-position-x: center;
            background-position-y: calc(50% - 140px);
            display: flex;
            justify-content: center;
            align-items: center;
            "
    >
        <div
            class="title-font-5 description-box"
        >
        ${this.message}
        </div>
    </div>
    `;
  }

  get image() {
    return this.getAttribute('image');
  }

  set image(value) {
    this.setAttribute('image', value);
  }

  setMessage(value) {
    this.shadowRoot.querySelector('.description-box').innerHTML = value;
  }
}
